/**
 * PaymentTimer.js
 *
 * Manages session timeout functionality for payment modal.
 */

export class PaymentTimer {
  constructor(sessionTimeout = 15 * 60, onTimeout = null) {
    this.sessionTimeout = sessionTimeout
    this.timeRemaining = sessionTimeout
    this.sessionTimer = null
    this.onTimeout = onTimeout
  }

  /**
   * Start the session countdown timer
   */
  start() {
    this.timeRemaining = this.sessionTimeout
    this.sessionTimer = setInterval(() => {
      this.timeRemaining--

      const countdown = document.getElementById('session-countdown')
      if (countdown) {
        countdown.textContent = this.formatTime(this.timeRemaining)
      }

      if (this.timeRemaining <= 0) {
        this.handleTimeout()
      }
    }, 1000)
  }

  /**
   * Stop the session timer
   */
  stop() {
    if (this.sessionTimer) {
      clearInterval(this.sessionTimer)
      this.sessionTimer = null
    }
  }

  /**
   * Handle session timeout
   */
  handleTimeout() {
    console.log('[PaymentTimer] Session timeout')
    this.stop()

    if (this.onTimeout && typeof this.onTimeout === 'function') {
      this.onTimeout()
    }
  }

  /**
   * Format seconds into MM:SS
   */
  formatTime(seconds) {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
  }

  /**
   * Reset timer to initial value
   */
  reset() {
    this.timeRemaining = this.sessionTimeout
  }
}
